import React from "react";
import { Stack, Typography } from "@mui/material";

import { BLOCK_BORDER_COLOR } from "../../../shared/constants";

interface PreviewCardProps {
  title: string;
  /** When true, highlight with purple border (active section in view). */
  active?: boolean;
  children: React.ReactNode;
}

/**
 * Standalone preview card used by the right-side preview pane.
 * Active state matches the Figma "selected" card (purple border).
 *
 * Specs source: Figma node 5383:9537 — heading body2 14px Regular, padding
 * 16px / 24px, gap 12px between rows, 12px border radius.
 */
const PreviewCard: React.FC<PreviewCardProps> = ({ title, active, children }) => (
  <Stack
    component="article"
    direction="column"
    gap={4}
    px={6}
    py={5}
    borderRadius={3}
    bgcolor="background.paper"
    sx={{
      border: `1px solid`,
      borderColor: active ? "primary.main" : BLOCK_BORDER_COLOR,
      transition: "border-color 150ms",
    }}
  >
    <Typography variant="body2" sx={{ letterSpacing: "0.17px", color: "text.primary" }}>
      {title}
    </Typography>
    <Stack gap={3}>{children}</Stack>
  </Stack>
);

export default PreviewCard;
